export function createModalGallery(images, tns) {
  if (images.length < 1) {
    return
  }

  const modalID = generateModalID()
  const listItems = images.map(createModalItemStructure)
  const galleryObject = buildModalGallery(modalID, listItems, tns)

  images.forEach((img, index) => {
    img.addEventListener('click', function () {
      OpenModal(modalID, galleryObject, index)
    })
  })
}

function createModalItemStructure(img) {
  const li = document.createElement('li')
  const figure = document.createElement('figure')
  const newImg = document.createElement('img')

  newImg.setAttribute('src', img.dataset?.src || img.src)
  newImg.setAttribute('alt', img.alt)
  newImg.setAttribute('title', img.title)

  figure.appendChild(newImg)
  li.appendChild(figure)

  return li
}

function generateModalID() {
  return 'modal-gallery' + (Math.floor(Math.random() * 10000) + 1)
}

function buildModalGallery(modalID, listItems, tns) {
  const modal = document.createElement('div')
  const listContainer = document.createElement('ul')
  const buttonClose = createCloseButton()

  listItems.forEach((li) => listContainer.appendChild(li))
  listContainer.classList.add('tns-gallery')

  modal.appendChild(buttonClose)
  modal.appendChild(listContainer)
  modal.setAttribute('id', modalID)
  modal.classList.add('ModalGallery')

  document.body.appendChild(modal)

  return tns({
    container: listContainer,
    gutter: 0,
    nav: false,
    autoHeight: true,
    items: 1,
    edgePadding: 0,
    preventScrollOnTouch: 'force',
  })
}

function OpenModal(modalID, gallery, positionImg = 0) {
  const modal = document.querySelector('#' + modalID)

  if (modal) {
    modal.classList.add('active')
    document.body.classList.add('lockscroll-active')
    gallery.goTo(positionImg)
  }
}

function createCloseButton() {
  const buttonClose = document.createElement('button')

  buttonClose.textContent = 'x'
  buttonClose.classList.add('ModalGallery__close')
  buttonClose.addEventListener('click', function () {
    CloseModal(this)
  })

  return buttonClose
}

function CloseModal(button) {
  if (button) {
    const modal = button.parentNode
    modal.classList.remove('active')
  }

  document.body.classList.remove('lockscroll-active')
}
